import React, { useState, useEffect } from "react";
import "../../../style/landing.css";

import frame from "../../../image/Frame 40.webp";
import frame1 from "../../../image/automated-testing.webp";
import frame2 from "../../../image/behavioral-personalization.webp";
import frame3 from "../../../image/engagement-scoring.webp";
import frame4 from "../../../image/predictive-recommendations.webp";
import { waitlist } from "../constants/Constants_Functions";
import { landing_status } from "../constants/Constants_Var";
import WaitlistSection from "../waitlist/WaitlistSection";
import AOS from "aos";
import "aos/dist/aos.css";

const features = [
  {
    img: frame,
    alt: "Newslettrai - Smart Send Optimization",
    title: "Smart Send Optimization",
    description:
      "Automatically send emails at the perfect time for each subscriber, boosting open rates effortlessly.",
    className: "card1",
  },
  {
    img: frame1,
    alt: "Newslettrai - Automated A/B Testing",
    title: "Automated A/B Testing",
    description:
      "Test and Optimize subject lines & content with actionable insights delivered automatically.",
    className: "card2",
  },
  {
    img: frame2,
    alt: "Newslettrai - Behavioral Personalization",
    title: "Behavioral Personalization",
    description:
      "Create dynamic, personalized content blocks that adapt to each subscriber’s preferences.",
    className: "card3",
  },
  {
    img: frame3,
    alt: "Newslettrai - Engagement Scoring",
    title: "Engagement Scoring",
    description:
      "Understand your audience with detailed engagement metrics to improve targeting and retention.",
    className: "card4",
  },
  {
    img: frame4,
    alt: "Newslettrai - Predictive Recommendations",
    title: "Predictive Recommendations",
    description:
      "Deliver tailored content suggestions based on user behavior, ensuring higher engagement.",
    className: "card5",
  },
];

const ProductOverview = () => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    AOS.init({
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      debounceDelay: 50,
      throttleDelay: 99,
      offset: 220,
      delay: 100,
      duration: 1000,
      easing: "ease",
      once: false,
    });
  }, []);

  return (
    <>
      <header>
        <h2 className="lp-product-heading">Product Overview</h2>
      </header>

      <section>
        <h2 className="lp-heading">Cutting-Edge Features</h2>
        <p className="lp-heading-desc">
          Effortlessly optimize send times, personalize content, and boost{" "}
          <br />
          engagement with AI-driven insights.
        </p>
      </section>

      <div className="lp-container">
        <div className="lp-product-section">
          {features.slice(0, 3).map((feature, index) => (
            <article
              key={index}
              className={`lp-product-card ${feature.className}`}
              data-aos="fade-up"
            >
              <img
                src={feature.img}
                alt={feature.alt}
                className="lp-card-img"
              />
              <h3>{feature.title}</h3>
              <p className="lp-text">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>

      <div className="lp-container">
        <div className="lp-product-section">
          {features.slice(3).map((feature, index) => (
            <article
              key={index}
              className={`lp-product-card ${feature.className}`}
            >
              <img
                src={feature.img}
                alt={feature.alt}
                className="lp-card-img"
              />
              <h3>{feature.title}</h3>
              <p className="lp-text">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>

      <WaitlistSection
        name="inputwaitlist5"
        email={email}
        setEmail={setEmail}
        waitlist={() => waitlist(email, setEmail, landing_status.waitlist)}
      />
    </>
  );
};

export default ProductOverview;
